export default {"src":"/_next/static/media/clock_icon.ff9c5328.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};